import { render, staticRenderFns } from "./AdminExclusiveProjectCard.vue?vue&type=template&id=1c9bf4ca"
import script from "./AdminExclusiveProjectCard.vue?vue&type=script&lang=js"
export * from "./AdminExclusiveProjectCard.vue?vue&type=script&lang=js"
import style0 from "../../../styles/home-page/admin.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports